import React from 'react';
import classnames from 'classnames';
import { ButtonProps } from '../types';

import './button.scss';

export const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
  const { title, icon, onClick, className, ...rest } = props;
  return (
    <button className={classnames('button', className)} onClick={onClick} {...rest}>
      {icon && <img src={icon} alt="icon" />}
      {title}
    </button>
  );
};
